import { onCartTrackEvent } from './onCartTrackEvent';
import { onCartItemCountUpdate } from './onCartItemCountUpdate';
import loggerService from '../../../utils/loggerService';
import {
  startTransaction,
  finishTransaction,
} from '../../../utils/transactionManager';

const cartPageEvent = {
  onTrackEvent: onCartTrackEvent,
  onCartItemCountUpdate: onCartItemCountUpdate,
  loggerService,
  performance: {
    transaction: {
      startTransaction: (options) => {
        return startTransaction({
          ...options,
          module: 'cartV2',
          op: 'cartV2.ui.action',
        });
      },
      finishTransaction,
    },
  },
};

export default cartPageEvent;
